"use client";

import { CSSProperties, FC, ReactNode, useEffect, useRef, useState } from "react";

interface BFLLazyLoadProps {
  children?: ReactNode;
  threshold?: number;
  style?: CSSProperties;
  triggerOnScroll?: boolean; // 👈 new
  className?: string;
}

const BFLLazyLoad: FC<BFLLazyLoadProps> = ({
  children,
  threshold = 1.0,
  style = {},
  triggerOnScroll = false,
  className = "",
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (shouldLoad) return;

    if (triggerOnScroll) {
      const onScroll = () => {
        setShouldLoad(true);
        window.removeEventListener("scroll", onScroll);
      };
      window.addEventListener("scroll", onScroll, { once: true });
      return () => window.removeEventListener("scroll", onScroll);
    } else {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            setShouldLoad(true);
            if (ref.current) observer.unobserve(ref.current);
          }
        },
        {
          rootMargin: "0px",
          threshold,
        }
      );
      if (ref.current) observer.observe(ref.current);
      return () => observer.disconnect();
    }
  }, [threshold, triggerOnScroll, shouldLoad]);

  return (
    <div ref={ref} className={className} style={style}>
      {shouldLoad && children}
    </div>
  );
};

export default BFLLazyLoad;
